import { Link } from "react-router";
import { Button } from "../../components/ui/button";
import { AlertCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

const UnauthorizedScreen = () => {
  const { t } = useTranslation("app");

  return (
    <div className="text-center">
      <div className="mb-8 flex justify-center">
        <AlertCircle className="h-20 w-20 text-danger" />
      </div>

      <h2 className="text-2xl font-bold text-foreground mb-2">
        {t("errors.unauthorizedTitle")}
      </h2>
      <p className="text-default-500 mb-6">{t("errors.unauthorizedBody")}</p>

      <div className="flex flex-col space-y-4">
        <Button asChild variant="default">
          <Link to="/">{t("errors.goHome")}</Link>
        </Button>

        <Button asChild variant="outline">
          <Link to="/dashboard">{t("errors.goDashboard")}</Link>
        </Button>
      </div>
    </div>
  );
};

export default UnauthorizedScreen;
